import { render } from "./DifferenceReason.vue?vue&type=template&id=1d427fc4&ts=true"
import script from "./DifferenceReason.vue?vue&type=script&lang=ts"
export * from "./DifferenceReason.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\source-ali\\Order-Management\\OrderManagement-Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__